/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_appsync_graphqlEndpoint": "https://64q5uy3nsfavngaq5hzfpix7ia.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-zzduwraobfeztikxrwtxhpmh6u",
    "aws_cognito_identity_pool_id": "us-east-2:63800ec1-443a-4da3-b8b2-6e7855527d75",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_hNr4D7RzJ",
    "aws_user_pools_web_client_id": "1orb41ftu6r76kkn7673jrf44t",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
